import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'YES Network',
    callsign: 'YESHDNY',
    logoUrl: networkLogos.yesnetwork.logoUrl,
    slug: 'yes-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="YESHDNY"
        title="Watch YES Network live with Fubo"
        networkName="YES Network"
        networkSet="baseball"
        customNetworks={['yesnetwork']}
      />
    </>
  )
}
